import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";

moment.defineLocale("en_APStyle", {
  parentLocale: "en",
  meridiem: function(hour, _, isLower) {
    const m = hour < 12 ? "a.m." : "p.m.";
    return isLower ? m : m.toUpperCase();
  }
});

//moment.locale("en_APStyle");

Vue.use(VueMoment, {
  moment
});
